import React, { forwardRef, useEffect, useState } from 'react'
import { styled } from '@linaria/react'
import { useAvivaSelector } from '@redux/hook';
import documentIcon from '@assets/icon/document-primary.svg';
import { css } from '@linaria/core';
import Icon from '@components/_Revamp/Icon';
import Listing, { Source } from '@components/_Revamp/Listing';
import { useDispatch } from 'react-redux';
import { updateSheetDisplay } from '@redux/slices/MLTC_R3/planBottomSheetSlice';
import _ from "lodash"; 
import { DEFAULT_DISCLAIMER_MSG, DISCLAIMER_TEXT } from '@static/content';
import { MLTC_DISCLAIMER_MIN_ANNUAL_PREMIUM } from '@static/staticConstents';
import { PLANS_NAME } from '@static/config';


export interface BottomSheetProps {
}
export interface SheetContainerProps {
  isVisible?: boolean
}
export interface BottomSheetContainerProps {
  isDisplaying?: boolean
}

const BottomSheet = forwardRef(({ ...props }: BottomSheetProps, ref) => {
  const dispatch = useDispatch();
  const planOverview = useAvivaSelector(state => state.mltcR3Step2.planOverview);
  const isQuoteConfirm = useAvivaSelector(state => state.mltcR3Step2.confirmQuotation);
  const isContentDisplay = useAvivaSelector(state => state.mltcR3PlanSheet.sheetDisplay);
  const disclaimerContentArray = [DEFAULT_DISCLAIMER_MSG]

  const [tempPlanOverview, setTempPlanOverview] = useState<any>(null);

  useEffect(() => {
    
    if (planOverview) {
      let copiedObject = _.cloneDeep(planOverview);
      setTempPlanOverview({ ...copiedObject });
    }

  }, [planOverview]);

  useEffect(() => {
    if (tempPlanOverview && isQuoteConfirm) {
      if(tempPlanOverview?.quoteBreakdown[1]?.descriptions[1])
      {
        let quoteBreakdownArr = tempPlanOverview.quoteBreakdown[1].descriptions[1].text.replaceAll('</p>','</p>|').split('|');
        quoteBreakdownArr.pop();
        quoteBreakdownArr.shift();
        tempPlanOverview.quoteBreakdown[1].descriptions[1].text = quoteBreakdownArr.join("");
      }
      else
      {
        tempPlanOverview.quoteBreakdown[1].descriptions.splice(1,1);
      }
    }
  }, [tempPlanOverview,isQuoteConfirm]);

  useEffect(()=>{
    if (isContentDisplay) {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";

    } else {
      document.body.style.overflow = "unset";
      document.body.style.touchAction = "unset";
    }
  },[isContentDisplay]);

  const toggleDisplay = () => {
    dispatch(updateSheetDisplay(!isContentDisplay));
  }

  const promoApplied = useAvivaSelector(state=>state?.mltcR3Step2?.sqsQuotation?.coverages[0]?.attributes?.promoCodeSummary) || "" ;
  const monthlyBenifitAmount = useAvivaSelector(state=>state.mltcR3Step2.quoteRawResponse?.coverages[0]?.attributes?.nonDiscountedTotalPremium);
  const CurrentPolicyFlow = useAvivaSelector(state=> state.loading.CurrentPolicyFlow.policy);

  if( CurrentPolicyFlow === PLANS_NAME.MLTC && 
      promoApplied?.includes("DBS") && 
      monthlyBenifitAmount >= MLTC_DISCLAIMER_MIN_ANNUAL_PREMIUM ){
    disclaimerContentArray.push(DISCLAIMER_TEXT)
  }

  return (
    <div>
      <OverlayDiv onClick={() => {
        dispatch(updateSheetDisplay(false));
      }} className={isContentDisplay ? `${OverlayDiv} ${OverlayDivVisible}` : `${OverlayDiv}`}></OverlayDiv>
      <SheetContainerWrapper isVisible={tempPlanOverview !== null && isQuoteConfirm}>
        <UpperContainer onClick={toggleDisplay}>
          <MenuIcon src={documentIcon} alt='need-help?' />
          <AccountBalanceValue>View Plan</AccountBalanceValue>
          <Icon
            className={!isContentDisplay ? `${IconRotate} ${IconPosition}` : IconPosition}
            name={'chevron-down-primary'}
          />
        </UpperContainer>
        <BottomContentContainerWrapper isDisplaying={isContentDisplay}>
          <BottomContentContainer >
            <Listing
              margin={"0"}
              sources={tempPlanOverview?.quoteBreakdown ? tempPlanOverview?.quoteBreakdown : planOverviewList}
              variant={'summarization'}
              summary={tempPlanOverview?.summary ? tempPlanOverview?.summary : summary}
              summaryTextFontSize={"16px"}
              dividerMarginBottom={"21px"}
              headerMaxValueWidth={"0"}
              showDisclaimer
              disclaimerText={disclaimerContentArray}
            />
          </BottomContentContainer>
        </BottomContentContainerWrapper>
      </SheetContainerWrapper>
    </div>
  )
});

export default BottomSheet



const SheetContainerWrapper = styled.div<SheetContainerProps>`
  display:none;
  z-index: 101;
  width: 100%;
  position:fixed;
  background-color:#FFF;
  bottom:0;
  left:0;
  right:0;
  border-radius: 10px 10px 0 0;
  box-shadow: 0px 0px 0px #c4c4c4, 0px -1px 3px #c4c4c4;
  @media screen and (max-width: 768px) {
    display:${props => props.isVisible ? "block" : "none"};
  }
`;

const UpperContainer = styled.div`
  display:flex;
  justify-content:center;
  flex-direction: row; 
  height: auto;
  padding:20px;
  column-gap: 8px;
  align-items: center;
  cursor: pointer;
`;


const MenuIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
`;

const AccountBalanceValue = styled.p`
  color: #883e89;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.015;
`;

const IconPosition = css`
  color: #883e89;
  width: 20px;
  height: 20px;
  object-fit: scale-down;
  
  @media screen and (min-width: 768px) {
    right: 0;
  }
  transform: translateY(-10%);
`;

const IconRotate = css`
  transform: translateY(-10%) rotate(180deg);
`;

const BottomContentContainerWrapper = styled.div<BottomSheetContainerProps>`
  z-index: 50;
  width: 100%;
  display:block;
  max-height: ${props => props.isDisplaying ? "800px" : "0px"};
  transition: max-height 0.3s linear;
`;

const BottomContentContainer = styled.div<BottomSheetContainerProps>`
  padding : 0 24px 24px 24px;
`;


const OverlayDiv = styled.div`
  z-index: 100;
  position:fixed;
  right:0;
  top:0;
  bottom:0;
  left:0;
  opacity: 0;
  visibility: hidden;
  background-color:rgba(1,1,1,0.5);
  transition:visibility 0.3s, opacity 0.3s linear;
 
`;

const OverlayDivVisible = css`
  opacity: 1;
  visibility: visible;
  @media screen and (min-width: 768px) {
    opacity: 0;
    visibility: hidden;
  }
`

const planOverviewList: Source[] = [
  {
    heading: { text: 'Plan overview' },
    descriptions: [
      { text: 'Plan selected', value: 'Singlife CareShield Standard' },
      { text: 'Monthly benefit', value: '-' },
    ],
  },
  {
    heading: { text: 'Premium breakdown' },
    descriptions: [
      {
        text: 'Annual premium',
        value: '-',
      },
      {
        text:
          'Cash Payment after CPF Medisave Deduction (CPF Medisave deduction $600)',
        value: '-',
      },
    ],
  },
];
const summary = { text: 'Total Annual Premium', value: '-' };
